import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Wordmark } from "../components/landing/Wordmark";
import { login } from "../lib/api";
import { EASE } from "../lib/motion";

export default function AdminLogin() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await login(email, password);
            // Auth is now stored in an httpOnly cookie by the server response.
            // Nothing to persist client-side; subsequent admin requests pick it up.
            toast.success("Welcome back, admin.");
            navigate("/admin");
        } catch (err) {
            const detail = err?.response?.data?.detail || "Could not sign in.";
            toast.error(typeof detail === "string" ? detail : "Could not sign in.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center px-6" data-testid="admin-login-page">
            <div className="noise-layer" aria-hidden />
            <motion.div
                initial={{ opacity: 0, y: 20, filter: "blur(8px)" }}
                animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                transition={{ duration: 1.0, ease: EASE }}
                className="w-full max-w-[460px] surface-card p-10"
            >
                <Wordmark />
                <div className="mt-8 text-xs uppercase tracking-[0.22em] text-oth-ink3 font-body">Admin portal</div>
                <h1 className="mt-2 font-display text-4xl font-semibold tracking-tight">Sign in</h1>
                <p className="mt-4 font-body text-sm text-oth-ink2">Only authorised stewards can modify the public site.</p>
                <form onSubmit={submit} className="mt-8 space-y-1" data-testid="admin-login-form">
                    <input type="email" className="field" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-login-email" />
                    <input type="password" className="field" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-login-password" />
                    <button type="submit" disabled={loading} className="btn-pill btn-pill-dark mt-8 w-full" data-testid="admin-login-submit">
                        {loading ? "Signing in..." : "Continue"} <ArrowUpRight size={14} />
                    </button>
                </form>
                <a href="/" className="mt-8 block text-center text-sm font-body text-oth-ink3 hover:text-oth-ink transition-colors" data-testid="admin-login-back">← Back to site</a>
            </motion.div>
        </div>
    );
}
